module.exports = __webpack_public_path__ + "img/withdraw-icon.373f8946.svg";